import { encode as base64_encode } from "base-64";
import config from "../config";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class MaintenanceDashboardStore {
  maintenanceData = [];
  piChartDta = [];
  monthlyMaintenanceData = [];
  weeklyMaintenanceData = [];

  rootStore;
  constructor(rootStore) {
    makeObservable(this, {
      maintenanceData: observable,
      piChartDta: observable,
      getDashboardCount: action,
      getMaintenancePieChart: action,
      getData: action,
      getVehicleWeeklyGraph: action,
      getVehicleMonthlyGraph: action,
      addaction: action,
      updatedistanceAll: action,
    });
    this.rootStore = rootStore;
  }

  async getDashboardCount({ companyId, userId, isadmin }) {
    // this.loading = true
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    // var response = await postApi
    //   .getClient("")
    //   .post(
    //     "index.php?c=maintenance&a=getDashboardCount",
    //     "postData=" + base64Input
    //   );

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/maintenanceDashboard/getDashboardCount", {
        params: postData,
      });

    this.maintenanceData = response?.data?.data;
    this.loading = false;
  }

  async getData({
    companyId,
    userId,
    isadmin,
    status,
    dueLimitTyre,
    dueLimit,
  }) {
    if (status == "Running") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getServiceReminderData",
      //     "postData=" + base64Input
      //   );

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getServiceReminderData", {
          params: postData,
        });

      this.serviceReminderData = response?.data?.data?.maintenancereport;
    } else if (status == "Idle") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
        dueLimitTyre: dueLimitTyre,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getTyreReminderData",
      //     "postData=" + base64Input
      //   );

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getTyreReminderData", {
          params: postData,
        });

      this.tyreReminderData = response?.data?.data?.maintenancereport;
    } else if (status == "Stop") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
        dueLimit: dueLimit,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getOilReminderData",
      //     "postData=" + base64Input
      //   );

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getOilReminderData", {
          params: postData,
        });

      this.oilReminderData = response?.data?.data?.maintenancereport;
    } else if (status == "exIdle") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getMulkiyaExpiryData",
      //     "postData=" + base64Input
      //   );

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getMulkiyaReminder", {
          params: postData,
        });
      this.mulkiyaReminderData = response?.data?.data?.maintenancereport;
    } else if (status == "NoData") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getInsuranceExpiryData",
      //     "postData=" + base64Input
      //   );

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getInsuranceReminder", {
          params: postData,
        });

      this.insuranceExpiryData = response?.data?.data?.maintenancereport;
    } else if (status == "batteryData") {
      var postData = {
        companyId: companyId,
        userId: userId,
        vehicleStatus: status,
        isadmin: isadmin,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient("")
      //   .post(
      //     "index.php?c=maintenance&a=getBatteryExpiryData",
      //     "postData=" + base64Input
      //   );
      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getBatteryChangeReminder", {
          params: postData,
        });

      this.batteryExpiryData = response?.data?.data?.maintenancereport;
    }

    this.loading = false;
  }

  async getVehicleMonthlyGraph({ companyId, userId, isadmin }) {
    var postData = { companyId: companyId, userId: userId, isadmin: isadmin };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=maintenance&a=getVehicleMonthlyGraph",
    //     "postData=" + base64Input
    //   );

    if (config.pythonReport === 1) {
      // postData.companyId=587
      var response = await postApi
        .getClient("report")
        .post("/graph/monthlyExpenses", postData);
    } else {
      response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getmaintenanceMonthlyGraph", {
          params: postData,
        });
    }

    // this.monthlyMaintenanceData = (response?.data?.data);
    var monthlyGraphData = response?.data?.data;

    if (monthlyGraphData) {
      monthlyGraphData.forEach((element) => {
        element.sumAmount = Number(element.sumAmount);
      });
    }
    this.monthlyMaintenanceData = monthlyGraphData;

    this.loading = false;
  }

  async getVehicleWeeklyGraph({ companyId, userId, isadmin }) {
    var postData = { companyId, userId, isadmin };

    if (config.pythonReport === 1) {
      // postData.companyId=587
      var response = await postApi
        .getClient("report")
        .post("/graph/weeklyExpenses", postData);
    } else {
      response = await postApi
        .getClient("NodeCoreUrl")
        .get("maintenanceDashboard/getmaintenanceWeeklyGraph", {
          params: postData,
        });
    }
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=maintenance&a=getVehicleWeeklyGraph",
    //     "postData=" + base64Input
    //   );

    // this.weeklyMaintenanceData = (response?.data?.data);
    var weeklyGraphData = response?.data?.data;
    if (weeklyGraphData) {
      weeklyGraphData.forEach((element) => {
        element.sumAmount = Number(element.sumAmount);
      });
    }
    this.weeklyMaintenanceData = weeklyGraphData;

    this.loading = false;
  }

  async getMaintenancePieChart(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=maintenance&a=getMaintenancePieChart",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("maintenanceDashboard/getmaintenancePieChart", {
        params: postData,
      });

    let piChartDta = response?.data?.data?.pieChart;

    piChartDta.forEach((val) => (val.value = val.data));
    this.piChartDta = piChartDta;
  }

  async addaction(data) {
    //updateServiceDistance
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=vehicle&a=updatedistanceService",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateServiceDistance", { postData });

    return response;
  }

  async addactionfortyre(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=vehicle&a=updatedistanceTyre",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateTyreDistance", { postData });

    return response;
  }

  async addactionforoil(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post(
    //     "index.php?c=vehicle&a=updatedistanceOil",
    //     "postData=" + base64Input
    //   );
    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateOilDistance", { postData });

    return response;
  }

  async addactionMulkiya(data) {
    var postData = data;

    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateMulkiyaDistance", { postData });

    return response;
  }
  async addactionInsurance(data) {
    var postData = data;

    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateInsuranceDistance", { postData });

    return response;
  }

  async addactionBatteryChange(data) {
    var postData = data;

    const response = await postApi
      .getClient("NodeCoreUrl")
      .post("maintenanceDashboard/updateBatteryDistance", { postData });

    return response;
  }
  async updatedistanceAll(data) {
    var postData = data;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "index.php?c=vehicle&a=updatedistanceAll",
        "postData=" + base64Input
      );

    return response;
  }

  async exportSerRemExcel(postData) {
    // console.log("getData", getData);
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportServiceReminderDataExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;//exportServiceReminderExcel

    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportServiceReminderExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Service_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportTyreRemExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportTyreReminderDataExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&dueLimitTyre=" +
    //   getData.dueLimitTyre +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;
    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportTyreReminderExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Tyre_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportOilExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportOilReminderDataExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&dueLimit=" +
    //   getData.dueLimit +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;

    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportOilReminderExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Oil_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportMulkiyaExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportMulkiyaExpiryExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;
    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportMulkiyaExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mulkiya_Expiry_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportInsuranceExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportInsuranceExpiryDataExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;
    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportInsuranceExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Insurance_Expiry_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportBatteryExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=maintenance&a=exportBatteryExpiryDataExcel&cid=" +
    //   getData.companyId +
    //   "&userCompany=" +
    //   getData.userCompany +
    //   "&userId=" +
    //   getData.userId +
    //   "&vehicleStatus=" +
    //   getData.vehicleStatus +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&colList=" +
    //   getData.colList;

    try {
      const response = await postApi.getClient("NodeCoreUrl").post(
        "maintenanceDashboard/exportBatteryChangeExcel",
        { postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Battery_Change_Expiry_Reminder_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default MaintenanceDashboardStore;
